document.addEventListener('click', function (e) {
  var btn = e.target.closest('.product-media-container__expand-video-button');
  if (!btn) return;

  var tryLoad = function (attemptsLeft) {
    var dialog = document.querySelector('.dialog-zoomed-gallery__dialog[open]');
    if (!dialog) {
      if (attemptsLeft > 0) return setTimeout(function () { tryLoad(attemptsLeft - 1); }, 100);
      return;
    }
    var videoSlide = dialog.querySelector('.dialog-zoomed-gallery .product-media-container--video');
    var playBtn = videoSlide && videoSlide.querySelector('.deferred-media__poster-button');
    if (playBtn) {
      playBtn.click();
    } else if (attemptsLeft > 0) {
      setTimeout(function () { tryLoad(attemptsLeft - 1); }, 100);
    }
  };

  tryLoad(10);
});
